const error = {
  INPUT_INVALID: '欄位輸入無效',
  MEDIA_ADMIN_DELETE_FAIL: '刪除圖片失敗',
  MERCHANT_ADMIN_MALICIOUS_ACTION: '您無權操作',
  MERCHANT_ADMIN_MERCHANT_INFO_IS_EMPTY: '查無此商家',
  MERCHANT_CASHFLOW_ADMIN_CREATE_FAIL: '金流申請錯誤',
  MERCHANT_FRONT_MERCHANT_FRONT_PLEASE_SUBSCRIBE_FIRST: '您的方案已過期，請重新訂閱',
  MERCHANT_FRONT_PLEASE_RENEW_SUBSCRIPTION: '您的方案已過期，請重新訂閱',
  MERCHANT_REACH_PROBATION_SMS_LIMIT: '已達試用期免費寄送上限',
  MERCHANT_FRONT_SUBSCRIPTION_EXPIRED: '請聯繫商店擁有者訂閱方案',
  MERCHANT_FRONT_PLEASE_BIND_CARD_FIRST: '請先綁定信用卡',
  MERCHANT_FRONT_PLEASE_CONTACT_BIND_CARD: '請聯繫管理者進行信用卡綁定',
  NEWEBPAY_CREDIT_CARD_SWIPE_TOKEN_FAIL: '綁定的信用卡刷卡失敗',
  NEWEBPAY_ISSUE_INVOICE_FAIL: '發票開立失敗',
  NEWEBPAY_ORDER_HAS_BEEN_REFUNDED: '此交易序號已退款',
  NEWEBPAY_ORDER_PAYMENT_FAIL: '此交易序號無付款成功',
  NEWEBPAY_PAYMENT_COLLECTING: '此交易正在請款中尚無法退款，請稍後再試',
  NEWEBPAY_QUERY_TRADE_INFO_FAIL: '藍新金流錯誤：查無此交易序號',
  NEWEBPAY_REFUND_FAIL: '此交易正在請款中尚無法退款，請稍後再試',
  NEWEBPAY_INVALID_REFUND_VALUE: '此訂單目前授權成功但尚未正式扣款，僅能整筆退款，無法部分退款',
  NEWEBPAY_CANCEL_AUTH_FAIL: '取消授權失敗',
  ORDER_ADMIN_INVENTORY_TIME_EXPIRED: '訂購的時段已過期',
  ORDER_ADMIN_INVENTORY_UNAVAILABLE: '庫存不足',
  ORDER_ADMIN_SEND_QRCODE_EMAIL_FAIL: 'Email 寄送失敗',
  ORDER_QRCODE_ADMIN_INVALID_QRCODE: '此憑證所屬訂單已取消，無法使用',
  ORDER_QRCODE_ADMIN_INVENTORY_NOT_MATCH: '此憑券非指定時段使用',
  ORDER_QRCODE_ADMIN_ITEM_NOT_EXIST: '查無此憑證',
  ORDER_QRCODE_ADMIN_PLEASE_CHECKOUT_FIRST: '此憑券尚未付款，無法使用',
  ORDER_QRCODE_ADMIN_PRODUCT_NOT_MATCH: '此憑券非指定項目使用',
  ORDER_QRCODE_ADMIN_QRCODE_EXPIRED: '此憑證已失效',
  ORDER_QRCODE_ADMIN_QRCODE_HAS_BEEN_VERIFIED: '此憑證已被使用',
  ORDER_ADMIN_SEND_CUSTOM_SMS_FAIL: '寄送簡訊通知失敗',
  PRODUCT_ADMIN_ITEM_NOT_EXIST: '您無權限瀏覽此商品',
  PRODUCT_ADMIN_STORE_WITH_EXIST_ALIAS: '此商品別名已存在。',
  PRODUCT_INVENTORY_ADMIN_INVENTORY_IS_OVERLAPPED: '時段與現有時段重疊',
  PRODUCT_PRICE_ADMIN_ITEM_NOT_EXIST: '查無此方案',
  PRODUCT_PRICE_ADMIN_SIZE_BIGGER_THAN_INVENTORY: '方案使用人數不可大於時段人數上限',
  PRODUCT_PRICE_ADMIN_DELETE_FAIL:'服務包含於包月方案中，請先將服務項目移出包月方案中，始得刪除',
  PREPAID_USAGE_RULES_UNAVAILABLE:'本次預約的時間在包月方案的使用範圍之外，請改期使用',
  PRODUCT_INVENTORY_GROUP_ADMIN_INVENTORY_WITH_ACTIVE_ORDERS: '無法移除時段，因尚有未取消之訂單',
  STATUS_CODE_UNDEFINED: '伺服器未定義錯誤狀態碼',
  USER_EMAIL_OR_PASSWORD_INCORRECT: 'Email 或密碼錯誤',
  USER_NOT_FOUND: '此 Email 尚未註冊',
  USER_TOKEN_EXPIRED: '登入已逾期，請重新登入',
  USER_UNACTIVATED: 'Email 尚未驗證',
  USER_UNAUTHORIZED: '請重新登入',
  USER_TOKEN_REVOKED: '此帳號已從不同裝置上登入',
  USER_IS_BLOCKED: '此帳號已停權',
  COUPON_ADMIN_ITEM_NOT_EXIST: '無效優惠券',
  COUPON_IS_NOT_AVAILABLE_FOR_MEMBER:'此會員不適用此優惠，請刪除優惠碼',
  COUPON_ADMIN_BASE_PRICE_IS_NOT_UP_TO_REBATE_PRICE: '您的消費金額未達使用門檻',
  COUPON_ADMIN_UNAVAILABLE: '優惠券已領取完畢',
  COUPON_ADMIN_UNUSABLE_PRODUCT: '此優惠券不適用結帳的商品',
  COUPON_BASE_PRICE_IS_NOT_UP_TO_REBATE_PRICE: '金額未達低消',
  COUPON_IS_NOT_IN_PROGRESS: '優惠卷目前不可使用',
  COUPON_UNAVAILABLE: '優惠券已達使用次數上限',
  COUPON_UNUSABLE_PRODUCT: '此活動不“適用”此優惠券',
  PREPAID_UNAVAILABLE: '包月方案已售完',
  PREPAID_ADMIN_SERVICE_STORE_INVALID:'僅限選取一間分店',
  SCHEDULE_CALENDAR_DETAIL_ADMIN_SCHEDULE_DUPLICATE: '與現有時段重疊',
  SCHEDULE_CALENDAR_ADMIN_NO_SCHEDULE: '該時段沒有排班',
  SCHEDULE_CALENDAR_DETAIL_ADMIN_EXCEED_MAX_DAYS: '僅接受：選擇日期之後的三個月內排班',
  SCHEDULE_CALENDAR_ADMIN_NON_BUSINESS_DAY: '非營業日',
  SCHEDULE_CALENDAR_ADMIN_TIME_HAS_EXPIRED: '該時段已過期',
  COUPON_ADMIN_CODE_EXIST: '折扣碼已存在',
  PRODUCT_PRICE_ADMIN_STORE_WITH_EXIST_ALIAS: '已存在相同的項目網址',
  SCHEDULE_CALENDAR_ADMIN_TIME_CONFLICT: '該時段已有其他預約',
  COUPON_UNUSABLE_PRODUCT_PRICE: '此服務不“適用”此優惠券',
  ORDER_ADD_ITEM_INVALID_STATUS_COMBINATION: '加購項目狀態組合錯誤',
  SCHEDULE_CALENDAR_DETAIL_ADMIN_HAVE_ORDER: '目前的排班項目上有訂單請先處理訂單',
  SCHEDULE_ITEM_ADMIN_HAVE_IN_PROGRESS_ORDER:' 目前排班中有訂單，無法刪除',
  SCHEDULE_ITEM_CALENDAR_TIME_UNAVAILABLE: '美容師發生撞單情形',
  ORDER_ADMIN_ORDER_NOT_BELONG_TO_YOU:'查無此訂單',
  ORDER_ADMIN_CHILDREN_ORDER_IS_PAID_AND_NOT_CANCEL:'請先取消子訂單',
  DEPOSIT_ADMIN_INSUFFICIENT_BALANCE:'儲值金餘額不足',
  MERCHANT_MEMBER_ADMIN_PHONE_EXIST: '此電話號碼已被使用過',
  MERCHENT_FRONT_SUBSCRIPTION_EXPIRED: '訂閱已到期',
  SCHEDULE_CALENDAR_ADMIN_HAVE_IN_PROGRESS_ORDER: '排班人員已有訂單，不可刪除',
  SERVICE_PET_SIZE_ADMIN_ITEM_NOT_EXIST: '此商品不存在'
}

export { error } 
